import { render, staticRenderFns } from "./agent_create.vue?vue&type=template&id=274b01a0&scoped=true"
import script from "./agent_create.vue?vue&type=script&lang=js"
export * from "./agent_create.vue?vue&type=script&lang=js"
import style0 from "./agent_create.vue?vue&type=style&index=0&id=274b01a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b01a0",
  null
  
)

export default component.exports